import {
  INTEGRATOR_HEADER_FIRST_LINE,
  INTEGRATOR_HEADER_SECOND_LINE,
  INTEGRATOR_BODY_FIRST_LINE,
  INTEGRATOR_BODY_SECOND_LINE,
} from '@/components/DashboardMovementRecords/IntegratorMovements/constants/integratorMovementsContants';

export default {
  data: () => ({
    integratorMovementTypes: [
      {id: 'UPDATE', name: 'Atualização'},
      {id: 'UPDATE_SUBCONTRACT', name: 'Atualização de subcontrato'},
      {id: 'DELETE', name: 'Exclusão'},
      {id: 'INSERT', name: 'Inclusão'},
    ],
    integratorMovementStatus: [
      {id: 'WAIT_SUBMISSION', name: 'Aguardando Envio'},
      {id: 'CANCELED', name: 'Cancelado'},
      {id: 'PENDING', name: 'Em processamento'},
      {id: 'INTEGRATION_ERROR', name: 'Falha Integração'},
      {id: 'INTEGRATION_SUCCESS', name: 'Integrado com Sucesso'},
    ],
    origins: [
      { id: 'MOV', name: 'Movimentação' },
      { id: 'CDP', name: 'Posição Cadastral' },
    ],
    logsStatus: [
      { id: 'SUCCESS', name: 'Sucesso' },
      { id: 'ERROR', name: 'Com erro' },
    ],
  }),

  methods: {
    getOriginNameById(originId) {
      if (!originId) return '';

      const integratorOrigin = this.origins.find(
        (origin) => origin.id === originId
      );

      if (integratorOrigin) {
        return integratorOrigin.name;
      }

      return ''
    },
    getIntegratorStatusName(statusId) {
      if (!statusId) return '';

      const integratorStatus = this.integratorMovementStatus.find(
        (status) => status.id === statusId
      );

      if (integratorStatus) {
        return integratorStatus.name;
      }

      return '';
    },
    getLogStatusName(statusId) {
      if (!statusId) return '';

      const logStatus = this.logsStatus.find(
        (status) => status.id === statusId
      );

      if (logStatus) {
        return logStatus.name;
      }

      return '';
    },
    getIntegratorTypeName(typeId) {
      if (!typeId) return '';

      const integratorType = this.integratorMovementTypes.find(
        (type) => type.id === typeId
      );

      if (integratorType) {
        return integratorType.name;
      }

      return '';
    },
  },

  computed: {
    headerFirstLine() {
      return INTEGRATOR_HEADER_FIRST_LINE;
    },
    headerSecondLine() {
      return INTEGRATOR_HEADER_SECOND_LINE;
    },
    bodyFirstLine() {
      return INTEGRATOR_BODY_FIRST_LINE;
    },
    bodySecondLine() {
      return INTEGRATOR_BODY_SECOND_LINE;
    },
  }
}
